import styled from '@emotion/styled';
import { spacing } from '@naf/theme';

export const Wrapper = styled.div`
  padding-top: ${spacing.space16};
`;
